import {useBreakpoint} from "./useBreakpoint";

export function useItemPerPage(breakpointItemsMap) {
    var breakpoint = useBreakpoint();
    switch (breakpoint) {
        case "xl": return breakpointItemsMap.xl;
        case "lg": return breakpointItemsMap.lg;
        case "md": return breakpointItemsMap.md;
        case "sm": return breakpointItemsMap.sm;
        default: return breakpointItemsMap.xs;
    }
}